import React, { useState, useEffect } from "react";
import axios from "axios";

import checkoutApi from "apis/checkout";
import SubscriptionModal from "components/Payment/SubscriptionModal";
import Card from "./challengeCard";
import { getStripe } from "utils/initStripe";
import { challengePrices, challenges } from "./constant";

function Challenges(props) {
  const [showSubModal, setShowSubModal] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [challengeDetails, setChallengeDeatils] = useState([]);
  const [priceId, setPriceId] = useState(null);
  const [trialEnd, setTrialEnd] = useState(null);

  const proceedToCheckout = async ({
    email,
    priceId,
    password,
    passwordConfirmation,
  }) => {
    try {
      const { data } = await checkoutApi.retrieve({
        email: email.toLowerCase(),
      });
      if (!data.allow_checkout) return;
      const stripe = await getStripe();
      const checkoutData = await checkoutApi.create({
        email: email.toLowerCase(),
        priceId,
        password,
        passwordConfirmation,
        trialEnd,
      });
      const { error: stripeError } = stripe.redirectToCheckout({
        sessionId: checkoutData?.data?.sessionId,
      });
      if (stripeError) alert(stripeError.message);
    } catch (error) {
      console.log("Proceed to checkout err:", error);
    }
  };

  const fetchPrices = async () => {
    try {
      const {
        data: { prices },
      } = await axios.get("/api/v1/prices");
      const subPrices = challengePrices(prices.data);
      setChallengeDeatils(challenges(subPrices));
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      <div className="">
        <div>
          <div className="container relative px-5 pb-20 mx-auto font-montserrat">
            <h2 className="text-3xl font-bold text-center text-black mb-15 md:text-4xl"></h2>
            <div className="text-center">
              <h1 className="font-semibold text-2xl text-gray-800">
                Access to the macros app with full features
              </h1>
            </div>

            <div className="w-full p-10 mx-auto bg-white rounded-2xl md:w-8/12">
              <div className="flex w-11/12 gap-10 mx-auto text-center justify-center">
                {challengeDetails.map(challenge => {
                  return (
                    <Card
                      key={challenge.title}
                      challenge={challenge}
                      setPriceId={setPriceId}
                      setShowSubModal={setShowSubModal}
                      setTrialEnd={setTrialEnd}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <SubscriptionModal
        isOpen={showSubModal}
        onClose={() => setShowSubModal(false)}
        proceedToCheckout={proceedToCheckout}
        stripePriceId={priceId}
      /> */}
    </>
  );
}

export default Challenges;
